<template>
    <div class="box">
        <div class="box-header"></div>
        <div class="box-content">
            <div class="item">
                <img src="@/assets/imgs/base_right/red_rank.png" class="header-image" />
                <div class="contents">
                    <div class="rank-item" v-for="(item,index) in rankObj['a']" :key="index">
                    <img src="@/assets/imgs/base_right/active_top.png" class="top-icon" />
                    <div class="rank-num">{{(index+1)<=9?'0'+(index+1):index+1}}</div>
                    <div class="rank-avart"></div>
                    <div class="rank-item-info">
                        <div class="info-title">{{item.score}}<span>分</span></div>
                        <div class="company-title">{{item.name}}</div>
                    </div>
                </div>
                </div>
            </div>
            <div class="item">
                <img src="@/assets/imgs/base_right/yellow.png" class="header-image" />
                <div class="contents">
                    <div class="rank-item" v-for="(item,index) in rankObj['b']" :key="index">
                    <img src="@/assets/imgs/base_right/top.png" class="top-icon" />
                    <div class="rank-num">{{(index+1)<=9?'0'+(index+1):index+1}}</div>
                    <div class="rank-avart"></div>
                    <div class="rank-item-info">
                        <div class="info-title">{{item.score}}<span>分</span></div>
                        <div class="company-title">{{item.name}}</div>
                    </div>
                </div>
                </div>
            </div>
            <div class="item">
                <img src="@/assets/imgs/base_right/blue.png" class="header-image" />
                <div class="contents">
                    <div class="rank-item" v-for="(item,index) in rankObj['c']" :key="index">
                    <img src="@/assets/imgs/base_right/active_top.png" class="top-icon" />
                    <div class="rank-num">{{(index+1)<=9?'0'+(index+1):(index+1)}}</div>
                    <div class="rank-avart"></div>
                    <div class="rank-item-info">
                        <div class="info-title">{{item.score}}<span>分</span></div>
                        <div class="company-title">{{item.name}}</div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {request_get} from "@/utils/request.js"
export default {
    data() {
        return {
            rankObj:{},
        }
    },
    mounted() {
        this.initRankReult()
    },
    methods:{
        initRankReult() {
            request_get("/lsd/scoreRanking/data",{},res => {
                if(res.code == 200) {
                    this.rankObj = res.data;
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.box{
    width:100%;
    height:100%;
    padding:15px;
    display: flex;
    flex-direction: column;
    background: linear-gradient(
      -270deg,
      rgba(37, 106, 191, 0.1) 0%,
      #031a37 100%
    );
    box-sizing: border-box;
    .box-header{
        width:100%;
        height:50px;
        background:url("../../assets/imgs/base_right/bg-5.png") no-repeat;
        background-size:581px 100%;
    }
    .box-content{
        flex:1;
        margin-top:40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item{
            width:394px;
            height:100%;
            
            padding:40px 20px;
            background: linear-gradient( 90deg, rgba(0, 20, 28, .1) 0%, rgba(1, 32, 45, .1) 50%, rgba(0, 20, 28, .1) 100%);
            position: relative;
            box-sizing: border-box;
            .contents{
                max-height:750px;
                overflow-y: auto;
            }
            .header-image{
                position: absolute;
                top:-20px;
                left:50%;
                transform: translate(-50%,0%);
                width:302px;
                height:40px;
            }
            .rank-item{
                width:100%;
                height:116px;
                background:rgba(255, 255, 255, 0.06);
                padding:16px 20px;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                position: relative;
                box-sizing: border-box;
                &:last-of-type{
                    margin-bottom: 0;
                }
                &:nth-of-type(1) {
                    .rank-num {
                        color:rgba(255, 197, 130, 1) !important;
                    }
                }
                &:nth-of-type(2) {
                    .rank-num {
                        color:rgba(199, 247, 251, 1) !important;
                    }
                }
                &:nth-of-type(3) {
                    .rank-num {
                        color:rgba(232, 137, 120, 1) !important;
                    }
                }
                .top-icon{
                    width:43px;
                    height:45px;
                    position: absolute;
                    top:0;
                    left:0;
                }
                .rank-num{
                    color:rgba(226, 253, 255, 0.40) !important;
                    font-size:32px;
                    font-weight: bold;
                }
                .rank-avart{
                    width:72px;
                    height:72px;
                    margin:0 20px;
                    img{
                        width:100%;
                        height: 100%;
                        border-radius: 50%;
                    }
                }
                .rank-item-info{
                    display: flex;
                    flex-direction: column;
                    .info-title{
                        color:rgba(130, 246, 255, 1);
                        font-size:24px;
                        font-weight: bold;
                        span{
                            font-size:14px;
                            font-weight: normal;
                        }
                    }
                    .company-title{
                        color:rgba(215, 239, 249, 0.90);
                        margin-top:2px;
                    }
                }
            }
        }
    }
}
::-webkit-scrollbar{
    display: none;
}
</style>